"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosError = void 0;
const axios_1 = __importDefault(require("axios"));
const sharedUtils_1 = require("./sharedUtils");
// if (process.env.NODE_ENV !== "production") {
// baseURL = "https://adopty.ru";
// }
const baseURL = sharedUtils_1.dev_env_object.API_BASE_URL;
const appAxios = axios_1.default.create({
    baseURL,
    timeout: 120000,
    withCredentials: true,
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "X-RELEASE-VERSION": RELEASE_VERSION,
    },
});
appAxios.interceptors.request.use((config) => {
    return config;
});
appAxios.interceptors.response.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    return config;
}));
function isAxiosError(error) {
    return axios_1.default.isAxiosError(error);
}
exports.isAxiosError = isAxiosError;
exports.default = appAxios;
